/**
 * 표시 통화 (FN-040 · SC-017).
 *
 * ⚠ **카드 에디션과 다른 축이다.** 에디션(EditionContext)은 "어느 시장의 시세를 볼지",
 * 이건 "그 값을 어느 통화로 적을지"다. 일본판 시세를 달러로 보는 조합이 정상이다.
 *
 * 기본은 원화(PRD §3.2). 서버가 내려주는 시세는 이미 KRW 로 환산된 값이라 KRW 를 고르면
 * 환산이 아예 일어나지 않는다 — 환율 파일을 못 받아도 기본 동작은 그대로다.
 */
import { create } from "zustand";

export const CURRENCY_STORAGE_KEY = "peeka.displayCurrency";

/** PRD §3.2 — 원화 기본. */
export const DEFAULT_DISPLAY_CURRENCY = "KRW";

function load(): string {
  try {
    return localStorage.getItem(CURRENCY_STORAGE_KEY) || DEFAULT_DISPLAY_CURRENCY;
  } catch {
    return DEFAULT_DISPLAY_CURRENCY;
  }
}

interface CurrencyState {
  currency: string;
  setCurrency: (next: string) => void;
}

export const useCurrencyStore = create<CurrencyState>((set) => ({
  currency: load(),
  setCurrency: (next) => {
    try {
      localStorage.setItem(CURRENCY_STORAGE_KEY, next);
    } catch {
      /* storage 불가 환경 — 이번 세션 동안만 유지된다 */
    }
    set({ currency: next });
  },
}));
